<script>
import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";

export default {
    name: "TotalAmountSpace",
    extends: TotalAmountsBase,
    props: {
        numberOfFiles: {
            type: Number,
            default: 0
        }
    },
    watch: {
        numberOfFiles(newVal) {
            this.amountsList = [];
            this.amountsList.push({text: this.$gettext("FILES"), amount: newVal});
        }
    },
    methods: {
        getTotalAmounts() {}
    }
}
</script>